import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_mentor_dashboard_data_action,
  get_all_interview_kit_data_action,
  get_mentor_profile_data_action,
  get_job_changes_notification_action,
  update_user_meta_data_action,
  user_meta_data_action,
} from "../../../redux/_actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function useRecruiterDashboard(props) {
  const [allAssignedJobs, setAllAssignedJobs] = useState({});
  const [assessmentKits, setAssessmentKits] = useState([]);
  const [assignedJobsLoading, setAssignedJobsLoading] = useState(false);
  const [assesmentKitsLoading, setAssessmentKitsLoading] = useState(false);
  const [mentorProfile, setMentorProfile] = useState({});
  const [jobChangesNotification, setJobChangesNotifications] = useState([]);
  const [resumeUploadModal, setResumeUploadModal] = useState(false);
  const [isResumeUpload, setIsResumeUpload] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mentorDashboardData } = useSelector(
    (state) => state.get_mentor_dashboard_data_reducer
  );
  const { allInterviewKitsData } = useSelector(
    (state) => state.get_all_interview_kit_data_reducer
  );

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { jobChangesNotificationData } = useSelector(
    (state) => state.get_job_changes_notification_reducer
  );

  useEffect(() => {
    getAssignedJobs();
    getAssessmentKits();
    callJobChangesNotificationsApi();
  }, []);

 
  useEffect(() => {
    if (mentorDashboardData?.data) {
      setAllAssignedJobs(mentorDashboardData?.data);
    }
  }, [mentorDashboardData]);
  useEffect(() => {
    if (allInterviewKitsData?.data) {
      setAssessmentKits(allInterviewKitsData?.data);
    }
  }, [allInterviewKitsData]);


  //notifications
  useEffect(() => {
    if (jobChangesNotificationData?.data) {
      setJobChangesNotifications(jobChangesNotificationData?.data);
    }
  }, [jobChangesNotificationData]);

  const getAssignedJobs = async () => {
    setAssignedJobsLoading(true);
    await dispatch(get_mentor_dashboard_data_action());
    await dispatch(user_meta_data_action());
    setAssignedJobsLoading(false);
  };
  const getAssessmentKits = async () => {
    setAssessmentKitsLoading(true);
    await dispatch(get_all_interview_kit_data_action());
    setAssessmentKitsLoading(false);
  };

  const onEditAssessmentKitClick = (id) => {
    if (id) {
      navigate(`/create-assessment/${id}`);
    } else navigate(`/create-assessment/`);
  };

  const onViewAssessmentsClick = () => {
    navigate("/mentor-assessment-kits");
  };
  const onViewCandidatesClick = (interviewKit) => {
    navigate(`/submitted-candidates-assessments/${interviewKit}`);
  };

  const callJobChangesNotificationsApi = async () => {
    await dispatch(get_job_changes_notification_action());
  };

  const onResumeUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        setIsResumeUpload(true);
        await dispatch(update_user_meta_data_action(data));
        getAssignedJobs();
        handleResumeUploadModal(false);
        setIsResumeUpload(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    } else {
      showWarningMessage("Resume Need to Uploaded");
    }
  };

  const handleResumeUploadModal = (type) => {
    setResumeUploadModal(type);
  };

  return {
    assessmentKits,
    assesmentKitsLoading,
    userMetaData,
    resumeUploadModal,
    isResumeUpload,

    onEditAssessmentKitClick,
    onViewAssessmentsClick,
    onViewCandidatesClick,
    handleResumeUploadModal,
    onResumeUpload,
  };
}
export default useRecruiterDashboard;
